import { useState } from "react";
import { ToastType, useToasts } from "src/components/Toasts";
import { Box, Button, NumberInput, Search, Text } from "src/elements";
import { ButtonDropdown } from "src/elements/Button";

const buttonDropdown: ButtonDropdown[] = [
	{ title: "Example 1", onClick: () => {} },
	{ title: "Example 2", onClick: () => {} },
	{ title: "Example 3", onClick: () => {} },
];

export const Playground = () => {
	const { toast, hideToast } = useToasts();

	const [_, setSearch] = useState("");

	const [number, setNumber] = useState(0);

	return (
		<>
			<NumberInput
				label="Number input"
				defaultValue={number}
				onChange={setNumber}
				min={1}
				max={10}
			/>

			<Search onChange={setSearch} width="200px" />

			<Box gap="20px" direction="column">
				<Text variant="h3">Toasts</Text>

				<Box gap="20px">
					<Button
						onClick={() => {
							toast({
								title: "Success message that is quite long to test wether the text breaks nicely",
								description: "Description of a message that was successful",
								type: ToastType.SUCCESS,
							});
							hideToast("pending");
						}}
					>
						Success
					</Button>

					<Button
						theme="greenSmoke"
						onClick={() => {
							toast({
								id: "pending",
								title: `
							What is Lorem Ipsum?
Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.

Why do we use it?
It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).
						`,
								description: `
							What is Lorem Ipsum?
Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.

Why do we use it?
It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).
						`,
								type: ToastType.PENDING,
							});
						}}
					>
						Pending
					</Button>

					<Button
						theme="yellow"
						onClick={() => {
							toast({
								title: "Warning without a description",
								type: ToastType.WARNING,
							});
						}}
					>
						Warning
					</Button>

					<Button
						theme="red"
						onClick={() => {
							toast({
								title: "Error",
								description: "Description",
								type: ToastType.ERROR,
							});
						}}
					>
						Error
					</Button>
				</Box>

				<Text variant="h3">Buttons</Text>

				<Box gap="20px">
					<Button>Primary</Button>

					<Button theme="greenSmoke">Green Smoke</Button>

					<Button theme="yellow">Yellow</Button>

					<Button theme="danger">Danger</Button>

					<Button theme="red">Red</Button>
				</Box>

				<Box gap="20px">
					<Button variant="inverted">Primary</Button>

					<Button theme="greenSmoke" variant="inverted">
						Green Smoke
					</Button>

					<Button theme="yellow" variant="inverted">
						Yellow
					</Button>

					<Button theme="danger" variant="inverted">
						Danger
					</Button>

					<Button theme="red" variant="inverted">
						Red
					</Button>
				</Box>

				<Box gap="20px">
					<Button disabled>Primary</Button>

					<Button theme="greenSmoke" disabled>
						Green Smoke
					</Button>

					<Button theme="yellow" disabled>
						Yellow
					</Button>

					<Button theme="danger" disabled>
						Danger
					</Button>

					<Button theme="red" disabled>
						Red
					</Button>
				</Box>

				<Box gap="20px">
					<Button dropdown={buttonDropdown}>Primary</Button>

					<Button theme="greenSmoke" dropdown={buttonDropdown}>
						Green Smoke
					</Button>

					<Button theme="yellow" dropdown={buttonDropdown}>
						Yellow
					</Button>

					<Button theme="danger" dropdown={buttonDropdown}>
						Danger
					</Button>

					<Button theme="red" dropdown={buttonDropdown}>
						Red
					</Button>
				</Box>
			</Box>
		</>
	);
};
